export const openCloseVariants = {
	open: { opacity: 1, height: 'auto' },
	collapsed: { opacity: 0, height: 0 }
}
